import { Turbo } from '@hotwired/turbo-rails';

// Lignes de tableau cliquables : navigue vers data-href sauf si le clic
// vise un élément interactif (bouton, lien, modale) contenu dans la ligne.
document.addEventListener('click', (event) => {
    const row = event.target.closest('tr[data-href]');
    if (!row || event.target.closest('button, a, dialog')) {
        return;
    }

    Turbo.visit(row.dataset.href);
});
